import { ref, computed } from 'vue';
import { apiFavoriteAll } from '@/request/api';

export default () => {
    const favoriteList = ref([]);
    const currentFavoriteId = ref('');

    // 获取所有收藏夹
    async function getFavoriteList() {
        const { data } = await apiFavoriteAll();
        favoriteList.value = data || [];
    }

    getFavoriteList();

    return { favoriteList, currentFavoriteId, getFavoriteList }
}